<template>
  <div>
    <Header/>
    <Navigationzj/>
    <div class="w1200">
      <div class="category-channel">
        <div v-for="(item,index) in Navigation" :key="index" class="category-channel-1">
          <div class="channel-1-title">
            <router-link :to="{path:'/Classify',query:{ grand_id:item.id }}">{{ item.title }}</router-link>
          </div>
          <div v-for="(i,u) in item.children" :key="u" class="category-channel-2">
            <div class="channel-2-li clearfix">
              <div class="channel-2-title">
                <router-link :to="{path:'/Classify',query:{ parent_id:i.id }}">{{ i.title }}</router-link>
              </div>
              <div class="category-channel-4 clearfix">
                <router-link :to="{path:'/Goods',query:{ cid:j.id }}" v-for="(j,y) in i.children" :key="y"><span class="channel-4-title">{{ j.title }}</span></router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Navigationzj from '@/components/Navigationzj'
import { mapGetters } from 'vuex'

export default {
  name: 'Sitemap',
  components: {
    Header,
    Navigationzj,
    Footer
  },
  data () {
    return {
      qyloading: false
    }
  },
  computed: {
    ...mapGetters([
      'Navigation'
    ])
  }
}
</script>
<style scoped>
a {
  text-decoration: none;
  color: #333;
}
.category-channel .category-channel-1 {
  margin-top: 30px;
}
.category-channel .category-channel-1 .channel-1-title {
  margin-bottom: 20px;
  font-size: 18px;
  line-height: 18px;
  text-align: center;
}
.category-channel .category-channel-2 {
  background-color: #f9f9f9;
  padding-top: 10px;
  color: #666;
  overflow: hidden;
  line-height: 24px;
}
.category-channel .category-channel-2 .channel-2-li {
  width: 100%;
  margin-bottom: 25px;
}
.category-channel .category-channel-2 .channel-2-li .channel-2-title {
  display: inline-block;
  float: left;
  width: 100px;
  margin-left: 20px;
  font-weight: 700;
}
.category-channel .category-channel-4 {
  display: inline-block;
  float: left;
  max-width: 1075px;
  margin-left: 5px;
  color: #666;
}
.category-channel .category-channel-4 .channel-4-title {
  display: inline-block;
  float: left;
  margin: 0 15px;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/view/sitemap/index.vue